import { render, staticRenderFns } from "./SearchDialog.vue?vue&type=template&id=d7a364d8&scoped=true&"
import script from "./SearchDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchDialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchDialog.vue?vue&type=style&index=0&id=d7a364d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a364d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7a364d8')) {
      api.createRecord('d7a364d8', component.options)
    } else {
      api.reload('d7a364d8', component.options)
    }
    module.hot.accept("./SearchDialog.vue?vue&type=template&id=d7a364d8&scoped=true&", function () {
      api.rerender('d7a364d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreSearch/components/SearchDialog.vue"
export default component.exports